export const calculateCourseHandicap = (playerHandicapIndex, slopeRating, courseRating, par) => {
    let handicap = Math.round(playerHandicapIndex * (slopeRating / 113) + (courseRating - par));
    return handicap;
};